export default __webpack_public_path__ + "static/media/add.e9dcb2f5.svg";